module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/92/assets/images/47e163e68e2a95c3286097cd25b2c053.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Diamond/Diamond0.svg
// module id = HnjT
// module chunks = 1